/* eslint-disable no-empty-pattern */
import React, { useState, useContext, useEffect } from "react";
import Lottie from 'react-lottie';
import kudaSuccessAnimation from '../../assets/animations/success.json'
import { StateContext } from "../../contextApi";
import { closeModalOnClick } from "../../util/util";

const SuccessModal = () => {
    const [state, setState] = useState({
        isStopped: true,
    })

    const [{ success }, dispatch] = useContext(StateContext)


    const closeModal = async () => {
        dispatch({
            newPayload: {
                status: false,
                message: "",
                header: "",
                button: ""
            },
            type: 'CHANGE_SUCCESS_MODAL'
        });
    }


    const handleAnim = () => {
        setState({ isStopped: false })
    }

    useEffect(() => {
        document.body.classList.add("backdrop-init");
        closeModalOnClick(closeModal);
        return () => {
            document.body.classList.remove("backdrop-init");
        }
    }, [])

    const defaultOptions = {
        loop: false,
        autoplay: false,
        animationData: kudaSuccessAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <React.Fragment>
            <div className="modal modal-sendMoney small-modal modal-backdrop fadeIn animated">
                <div className="modal-content fadeInUp animated">
                    <div className="kuda-modal--content">
                        <h4 className="color-black text-xbold margin-bottom--spacer text-center">{success.header}</h4>

                        <div className="kuda-modal-illustration">
                            <Lottie options={defaultOptions}
                                height={`100%`}
                                width={`100%`}
                                isStopped={state.isStopped}
                                eventListeners={
                                    [
                                        {
                                            eventName: 'DOMLoaded',
                                            callback: anim => handleAnim(anim),
                                        },
                                    ]
                                }
                            />
                        </div>
                        <div className="message-response withdrawal-response text-center bottom--spacing">
                            <p className="color-black">{success.message}</p>
                        </div>

                        <div className="d-flex justify-content-center mt-5">
                            <div className="addAction kuda-cta kuda-cta-lg" onClick={closeModal}>{success.button}</div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default SuccessModal;